// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Header from './Header'
// import RegisterComplaint from './pages/RegisterCom/RegisterCom';
// import RequestStatus from './pages/RequestStatus/RequestStatus';

// function App() {
//   return (
//     <Router>
//       <Header />
//       <Routes>
//         <Route path="/"  element={<Navigate to="/registerComplaint" replace /> } />
//         <Route path="/registerComplaint" element={<RegisterComplaint/>} />
//         {/* <Route path="/incidents" element={<Incidents />} /> */}
//         <Route path="/requestStatus" element={<RequestStatus />} />
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './Header';  // Adjust paths if needed
import Footer from './pages/Footer/Footer';
import RegisterComplaint from './pages/RegisterCom/RegisterCom';
import RequestStatus from './pages/RequestStatus/RequestStatus';

const App = () => {
  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<RegisterComplaint />} />
            <Route path="/requestStatus" element={<RequestStatus />} />
            <Route path="*" element={<Navigate to="/register-complaint" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
